export type GridSize = "small";

export const getLabelSize = (size: GridSize) => {
  switch (size) {
    case "small":
      return "144px";
  }
};
